interface Props { status: string }
export function StatusPill({ status }: Props) {
  const map: Record<string, string> = {
    pending: 'bg-slate-100 text-slate-700 animate-pulse',
    in_progress: 'bg-blue-100 text-blue-700 animate-pulse',
    success: 'bg-emerald-100 text-emerald-700',
    failed: 'bg-red-100 text-red-700',
  };
  const cls = map[status] ?? 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-xs font-semibold ${cls}`}>
      {status}
    </span>
  );
}
